import { LangContext } from "@context/Lang/LangContext";
import { LangDto } from "@client/common";
import { useEffect, useState } from "react";
import { useAppTranslation } from "@hooks/useAppTranslation";

type LangContextProviderProps = {
  children: React.ReactNode;
};

const LangContextProvider = ({ children }: LangContextProviderProps) => {
  const { i18n } = useAppTranslation();
  const [lang, setLang] = useState<LangDto>(LangDto.PL);

  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [i18n, lang]);

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      {children}
    </LangContext.Provider>
  );
};

export default LangContextProvider;
